<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 col-sm-12">
      <div class="card">
        <div class="card-header">
          <div class="row justify-content-between">
            <h1 class="title mb-0 col-md-10">Request Details</h1>
            <div class="col-md-2" *ngIf="request?.canCancel">
              <button class="btn btn-danger float-right" (click)="cancelClicked($event)">
                Cancel
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row steps-action centered d-flex flex-column align-items-center justify-content-center">
            <div class="request-det-body body">
              <div class="card-body request-det">
                <!-- patient personal details -->
                <div class="data-card">
                  <h1 class="mb-2 mt-4">Patient Personal Details</h1>
                  <div class="data-container mt-3">
                    <div class="row">
                      <div class="data col-xl-3">
                        <h6>Full Name</h6>
                        <h4>{{ request?.patient?.fullName }}</h4>
                      </div>
                      <div class="data col-3">
                        <h6>National ID / Passport ID</h6>
                        <h4>{{ nationalIdAndPassportId }}</h4>
                      </div>

                      <div class="data col-3">
                        <h6>Mobile Number</h6>
                        <h4>{{ request?.patient?.phone }}</h4>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Request Details -->
                <div class="data-card">
                  <h1 class="">Request Details</h1>

                  <div class="data-container mt-3">
                    <div class="row">
                      <div class="col-3">
                        <div class="data">
                          <h6>PSP Code</h6>
                          <h4>{{ request?.patient?.requestCompanyPspCode || '--' }}</h4>
                        </div>
                      </div>

                      <div class="col-3">
                        <div class="data">
                          <h6>Doctor Code</h6>
                          <h4>{{ request?.doctorCode || '--' }}</h4>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="data">
                          <h6>Request Id</h6>
                          <h4>{{ request?.id }}</h4>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="data">
                          <h6>Request Date</h6>
                          <h4>{{ request?.creationDate | date }}</h4>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="data">
                          <h6>Request Type</h6>
                          <h4>
                            {{
                            request?.typeId == 1 ? "Home Delivery" : "Pickup"
                            }}
                          </h4>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="data">
                          <h6>Status</h6>
                          <h4>
                            {{
                            request?.statusId == 1
                            ? "Pending"
                            : request?.statusId == 2
                            ? "Confirmed"
                            : request?.statusId == 3
                            ? "Out for delivery"
                            : request?.statusId == 4
                            ? "Delivered"
                            : request?.statusId == 5
                            ? "Cancelled"
                            : request?.statusId == 6
                            ? "Expired"
                            : request?.statusId == 7
                            ? "Pending Receipt"
                            : ""
                            }}
                          </h4>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="data">
                          <h6>Program Name</h6>
                          <h4>{{ request?.programName }}</h4>
                        </div>
                      </div>
                      <div *ngIf="request?.referralCenter" class="col-3">
                        <div class="data">
                          <h6>Dispensing Center</h6>
                          <h4>{{ request?.referralCenter }}</h4>
                        </div>
                      </div>
                      <div *ngIf="request?.insulinType" class="col-3">
                        <div class="data">
                          <h6>Patient's Insulin Type</h6>
                          <h4>{{ request?.insulinType }}</h4>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="data">
                          <h6>Channel</h6>
                          <h4>
                            {{
                            request?.channelId == 1
                            ? "Call"
                            : request?.channelId == 2
                            ? "Application"
                            : "Pharmacy"
                            }}
                          </h4>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="data">
                          <h6>Free of Charge Count</h6>
                          <h4>{{ request?.freeOfChargeCount || '--' }}</h4>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="data">
                          <h6>Empty Boxes Count</h6>
                          <h4>{{ request?.emptyBoxesCount || '--' }}</h4>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="data">
                          <h6>Sales/Purchases Count</h6>
                          <h4>{{ request?.purchasesCount || '--' }}</h4>
                        </div>
                      </div>

                      <div class="col-3">
                        <div class="data">
                          <h6>Discount Applied</h6>
                          <h4>{{ request?.discountField ? 'Yes' : request?.discountField === false ? 'No' : '--' }}</h4>
                        </div>
                      </div>


                      <div class="col-3">
                        <div class="data">
                          <h6>Order Quantity</h6>
                          <h4>{{ request?.theOrderQuantity || '--' }}</h4>
                        </div>
                      </div>

                      <div class="col-3">
                        <div class="data">
                          <h6>Total Public Price</h6>
                          <h4>{{ request?.totalPublicPrice || '--' }}</h4>
                        </div>
                      </div>

                      <div class="col-3">
                        <div class="data">
                          <h6>Discount Percentage</h6>
                          <h4>{{ request?.percentageOfTheDiscount || '--' }}</h4>
                        </div>
                      </div>

                      <div class="col-3">
                        <div class="data">
                          <h6>Total Price After Discount</h6>
                          <h4>{{ request?.totalPriceAfterDiscount || '--' }}</h4>
                        </div>
                      </div>

                      <div class="col-3">
                        <div class="data">
                          <h6>Delivery Date</h6>
                          <h4>{{ (request?.dischargeDate | date) || '--'}}</h4>
                        </div>
                      </div>

                      <div class="col-3">
                        <div class="data">
                          <h6>Payment Methods</h6>
                          <h4>{{ (request?.paymentMethods || []).join(', ') || '--'}}</h4>
                        </div>
                      </div>

                      <div class="col-6">
                        <div class="data">
                          <h6>Pack's Serial Numbers 
                            <a href="#" 
                               (click)="onSerialNumberDocumentButtonClick($event)"
                               [class.disabled]="!hasSerialNumberDocument()"
                               [style.pointer-events]="!hasSerialNumberDocument() ? 'none' : 'auto'"
                               [style.color]="!hasSerialNumberDocument() ? '#999' : '#233dd2'"
                               style="text-decoration: underline; margin-left: 5px;">View</a>
                          </h6>
                          <h4 *ngIf="!request.boxes || request.boxes.length === 0">--</h4>
                          <span *ngIf="request.boxes && request.boxes.length === 1">
                            Pack Serial Number: {{ request.boxes[0].serialNumber }}
                          </span>
                          <span *ngIf="request.boxes && request.boxes.length > 1" 
                                [innerHTML]="getBoxesTooltip(request.boxes)">
                          </span>
                        </div>
                      </div>

                      <div class="col-3">
                        <div class="data">
                          <h6>Receipt</h6>
                          <button class="btn btn-success" 
                            (click)="onReceiptDocumentButtonClick($event)"
                            (dblclick)="onReceiptDocumentButtonClick($event)"
                            [disabled]="!hasReceiptDocument()">
                            Preview
                          </button>
                        </div>
                      </div>

                      <div class="col-3" *ngIf="request?.cancellationReason">
                        <div class="data">
                          <h6>Cancellation Reason</h6>
                          <h4>{{ request?.cancellationReason }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Selected Area -->
                <div *ngIf="request?.patientAddressData" class="data-card">
                  <h1 class="mb-2">Selected Area</h1>
                  <div class="data-container mt-3">
                    <div class="row">
                      <div class="col-3">
                        <div class="data">
                          <h6>City</h6>
                          <h4>{{ request?.patientCity }}</h4>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="data">
                          <h6>Area</h6>
                          <h4>{{ request?.patientArea }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Pharmacy -->
                <div class="data-card" *ngIf="(request?.statusId != 5 && request?.statusId != 6)
                  || request?.pharmacy">
                  <h1 class="mb-2">Pharmacy</h1>
                  <div class="data-container mt-3" *ngIf="request?.pharmacy; else noPharmacy">
                    <div class="row">
                      <div class="col-3">
                        <div class="data">
                          <h6>Pharmacy Name</h6>
                          <h4>{{ request?.pharmacy?.name }}</h4>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="data">
                          <h6>Phone Number</h6>
                          <h4>{{request?.pharmacy?.phone || request?.pharmacy?.hotline}}</h4>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3">
                        <div class="data">
                          <h6>City</h6>
                          <h4>{{request?.cityName}}</h4>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="data">
                          <h6>Area</h6>
                          <h4>{{request?.areaName}}</h4>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="data">
                          <h6>Address</h6>
                          <h4>{{ request?.pharmacy?.address }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-template #noPharmacy>
                    <div
                      class="data-container pointer mb-3 mt-3 no-data d-flex justify-content-center align-items-center"
                      (click)="routeToSelectPharmacy()">
                      <h3>Select Pharmacy</h3>
                    </div>
                  </ng-template>
                </div>

                <!-- Notes -->
                <div class="data-card" *ngIf="(request?.statusId != 5 && request?.statusId != 6)
                  || request?.notes">
                  <h1 class="mb-2">
                    Request Notes
                    <em *ngIf="
                        request?.notes &&
                        request?.statusId !== 3 && request?.statusId !== 4 && request?.statusId !== 5
                          && request?.statusId !== 6
                      " (click)="openModal(addNote, 'md')" class="edit-icon"><i class="fas fa-pen"></i></em>
                  </h1>
                  <div class="data-container mt-3" *ngIf="request?.notes; else noNotes">
                    <div class="row">
                      <div class="col-3">
                        <div class="data">
                          <h6>Additional Notes</h6>
                          <h4>{{ request?.notes }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-template #noNotes>
                    <div class="row" *ngIf="
                        request?.statusId == 3 || request?.statusId == 4;
                        else addNewNote
                      ">
                      <div class="col-3">
                        <div class="data">
                          <h6>Expectation Notes</h6>
                          <h4>-</h4>
                        </div>
                      </div>
                    </div>
                    <ng-template #addNewNote>
                      <div class="data-container pointer mt-3 no-data d-flex justify-content-center align-items-center"
                        (click)="openModal(addNote)">
                        <h3>Add Additional Notes</h3>
                      </div>
                    </ng-template>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #addNote let-d="dismiss">
    <div class="modal-header">
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" (click)="d()">
        <span aria-hidden="true"> × </span>
      </button>
    </div>
    <div class="modal-body">
      <div class="pharmacies">
        <div class="card-header">
          <div class="header">
            <h2>Add Additional Note</h2>
            <span> This note will appear to pharmacy in request details. </span>
          </div>

          <div class="search pr-3 mt-3">
            <label for=""> Additional Note</label>
            <textarea rows="5" class="search-p" type="text" name="search" id="src_txt" [value]="request?.notes"
              #notes></textarea>
          </div>
        </div>
      </div>

      <div class="card-footer">
        <div class="row step-footer mt-4 mb-5">
          <div class="col-10 d-flex justify-content-center">
            <button type="submit" class="btn btn-psp-primary btn-round" (click)="addRequestNote(notes.value)">
              {{ request?.notes ? "Edit" : "Save" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>